import type { ReactNode } from "react";
import type { Optional } from "../../types";
import type { VehicleCardRecommendationImageProps } from "./vehicle-card-recommendation.component";
import styles from "./vehicle-card-recommendation-image-desktop.module.css";

export type VehicleCardImageRecommendationDesktopProps  = {
  src: string;
  title: string;
  onImageRender?: Optional<
    (props: VehicleCardRecommendationImageProps) => ReactNode
  >;
  imageWidth?: number;
};

export function VehicleCardImageRecommendationDesktop({
  src,
  title,
  onImageRender,
  imageWidth = 242,
}: Readonly<VehicleCardImageRecommendationDesktopProps>) {
  const props = {
    src,
    title,
    height: 190,
    width: imageWidth,
    alt: title,
    className: styles.Image,
  };
  return (
    <div 
      className={`${styles.Container} ${imageWidth ? styles.ImageWidth : ""}`}
      style={{
        "--image-width": `${imageWidth}px`,
      } as React.CSSProperties}
    >
      {onImageRender ? onImageRender(props) : <img {...props} />}
    </div>
  );
}
